// Internal module imports
import { HttpClient } from '../utils/httpClient';

const PATH = {
    read: '/admin/eic/redis-data',
    logs: '/admin/eic/logs',
    powerLogs: '/admin/eic/power-logs',
    updateRedisValue: '/admin/eic/redis-value',
    eicCodes: '/admin/eic/eic-codes',
    eicLogs: '/admin/eic/eic-logs',
    eicSignalLogs: '/admin/eic/eic-signal-logs',
    activationEvents: '/admin/eic/activation-events',
    activationEventsByArea: '/admin/eic/activation-events-area',
    activationEdgeEvents: '/admin/eic/activation-edge-events',
};

const GetRedisData = (params, start, callback, error, next) => {
    start();
    return HttpClient.get(PATH.read, { params }).then(callback).catch(error).finally(next);
};
const GetLogs = (params, start, callback, error, next) => {
    start();
    return HttpClient.get(PATH.logs, { params }).then(callback).catch(error).finally(next);
};

const GetPowerLogs = (params, start, callback, error, next) => {
    start();
    return HttpClient.get(PATH.powerLogs, { params }).then(callback).catch(error).finally(next);
};

const UpdateRedisValue = (payload, start, callback, error, next) => {
    start();
    return HttpClient.patch(`${PATH.updateRedisValue}`, payload).then(callback).catch(error).finally(next);
};

const GetEicCodes = (start, callback, error, next) => {
    start();
    return HttpClient.get(PATH.eicCodes).then(callback).catch(error).finally(next);
};

const GetEicLogs = (params, start, callback, error, next) => {
    start();
    return HttpClient.get(PATH.eicLogs, { params }).then(callback).catch(error).finally(next);
};

const GetEicSignalLogs = (params, start, callback, error, next) => {
    start();
    return HttpClient.get(PATH.eicSignalLogs, { params }).then(callback).catch(error).finally(next);
};

const GetActivationEvents = (params, start, callback, error, next) => {
    start();
    return HttpClient.get(PATH.activationEvents, { params }).then(callback).catch(error).finally(next);
};

const GetActivationByArea = (params, start, callback, error, next) => {
    start();
    return HttpClient.get(PATH.activationEventsByArea, { params }).then(callback).catch(error).finally(next);
};

const GetActivationEdgeEvents = (params, start, callback, error, next) => {
    start();
    return HttpClient.get(PATH.activationEdgeEvents, { params }).then(callback).catch(error).finally(next);
};

export const EicService = {
    GetRedisData,
    GetLogs,
    GetPowerLogs,
    UpdateRedisValue,
    GetEicCodes,
    GetEicLogs,
    GetEicSignalLogs,
    GetActivationEvents,
    GetActivationByArea,
    GetActivationEdgeEvents,
};
